module.exports = __webpack_public_path__ + "static/media/clock.376eb20d.svg";